<template>
  <div class="login">
    <Banner
      :title="'LOGIN'"
      :class-banner="'common-banner'"
    />
    <div class="login__title">
      Please complete below form to login. All fields are mandatory
    </div>
    <div class="login__input-cell-phone login__input-common">
      <b-input-group>
        <template #prepend>
          <b-input-group-text >{{callingCode}}</b-input-group-text>
        </template>
        <b-form-input
          type="number"
          v-model="phone"
          placeholder="Cellphone"
        />
      </b-input-group>
    </div>
    <div class="login__input-password login__input-common">
      <img class="icon-input" src="@/assets/images/login/password.png"/>
      <b-form-input
        type="password"
        v-model="password"
        placeholder="Password"
      />
    </div>
    <div class="login__button-login">
      <b-button @click="handleLogin">Login</b-button>
    </div>
    <div class="login__forgot-register">
      <div @click="$router.push('/forgot-password')" class="forgot-password-bottom">Forgot password</div>
      <div class="line">|</div>
      <div @click="$router.push('/register')" class="register-bottom">Register</div>
    </div>
  </div>
</template>
<script>
import Banner from '@/components/common/banner';
import authService from '@/services/auth.service';
const CALLINGCODE = process.env.VUE_APP_CALLING_CODE;
export default {
  components: {
    Banner
  },
  data() {
    return {
      callingCode: "+" + CALLINGCODE,
      phone: '',
      password: ''
    }
  },
  methods: {
    handleLogin() {
      authService.login(this.phone, this.password).then((res) => {
        if (res.status === 'success') {
          this.$bvToast.toast('Login successfully', {
            title: 'Successfully',
            variant: 'success',
            solid: true,
            autoHideDelay: 5000
          });
          this.$store.commit('loginUser');
          this.$router.push('/account');
        } else {
          const message = res.message;
          this.$bvToast.toast(message, {
            title: 'Failed',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          })
        }

      },
      () => this.$bvToast.toast('Login failed! Please try again', {
        title: 'Failed',
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000
      }));
    }
  }
}
</script>
